import { NotificationContextProvider } from './state/notification';
import { ProposalContextProvider } from './state/proposalCenter';

import combineComponents from './utils/combineComponents';

const providers = [
  NotificationContextProvider,
  ProposalContextProvider,
];

const AppContextProvider = combineComponents(...providers);
export default AppContextProvider;
